export default __webpack_public_path__ + "static/media/icon-begin-assessment-new.f3007d6a.svg";